/**
 * FontAwesome Icon Library Configuration
 *
 * This file imports only the specific icons used in the application
 * instead of entire icon sets, reducing bundle size significantly.
 *
 * If you need to add new icons:
 * 1. Import the specific icon from the appropriate package
 * 2. Add it to the library.add() call
 */

import { library } from '@fortawesome/fontawesome-svg-core';

// Regular icons (far)
import {
  faEnvelope as farEnvelope,
  faFilePdf as farFilePdf,
  faBell as farBell,
  faBellSlash as farBellSlash,
  faBellOn as farBellOn,
  faBellPlus as farBellPlus,
  faSlidersV as farSlidersV,
} from '@fortawesome/pro-regular-svg-icons';

// Solid icons (fas)
import {
  faFilePdf as fasFilePdf,
  // Common alert type icons - add more as needed based on your data
  faExclamationTriangle as fasExclamationTriangle,
  faInfoCircle as fasInfoCircle,
  faExclamationCircle as fasExclamationCircle,
  faTrafficLight as fasTrafficLight,
  faRoad as fasRoad,
  faConstruction as fasConstruction,
  faBell as fasBell,
  faCalendarAlt as fasCalendarAlt,
  faMapMarkerAlt as fasMapMarkerAlt,
  faWrench as fasWrench,
  faHardHat as fasHardHat,
  faClock as fasClock,
} from '@fortawesome/pro-solid-svg-icons';

// Initialize the library with only the icons we need
export function initFontAwesome(): void {
  library.add(
    // Regular icons
    farEnvelope,
    farFilePdf,
    farBell,
    farBellSlash,
    farBellOn,
    farBellPlus,
    farSlidersV,
    // Solid icons
    fasFilePdf,
    fasExclamationTriangle,
    fasInfoCircle,
    fasExclamationCircle,
    fasTrafficLight,
    fasRoad,
    fasConstruction,
    fasBell,
    fasCalendarAlt,
    fasMapMarkerAlt,
    fasWrench,
    fasHardHat,
    fasClock
  );
}
